import React, { Component } from 'react';

import { Drag } from 'components/drag';
import { inject, observer } from 'mobx-react';
import PropTypes from 'prop-types';

import SubtitleActions from '../SubtitleActions';

@inject((stores) => ({
  position: stores.SubtitleStore.referenceLinePosition,
  zoom: stores.SubtitleStore.zoom
}))
@observer
export default class SubtitleTimelineReferenceLine extends Component {
  referenceLine = React.createRef();

  static propTypes = {
    position: PropTypes.number,
    timelineWidth: PropTypes.number,
    zoom: PropTypes.number
  };

  get scrollWidth() {
    return (
      this.referenceLine.current &&
      this.referenceLine.current.parentNode.getBoundingClientRect().width
    );
  }

  get position() {
    const { position } = this.props;

    // eslint-disable-next-line @typescript-eslint/no-magic-numbers
    return position * 100;
  }

  componentDidUpdate(nextProps) {
    if (nextProps.zoom !== this.props.zoom) {
      this.changePosition(0);
    }
  }

  render() {
    return (
      <Drag onCueMove={this.changePosition}>
        <span
          ref={this.referenceLine}
          className="subtitle__timeline__reference__line"
          style={{ left: `${this.position}%` }}
        ></span>
      </Drag>
    );
  }

  changePosition = (pixelsMoved) => {
    const { timelineWidth } = this.props;

    SubtitleActions.moveReferenceLine(
      pixelsMoved,
      this.scrollWidth,
      timelineWidth
    );
  };
}
